<template>
  <Page>
    <SidePageColumn side="left">
      <QuickSideLinks :quick_links="quick_links"></QuickSideLinks>
      <v-divider class="mt-4"></v-divider>
      <FeaturedSidePromotions :page="page" section="left" ></FeaturedSidePromotions>
    </SidePageColumn>

    <CenterPageColumn :has_nav_bar="true" >
      <CenterNavbar :crumps="[]" title="Contact Us" :width_class="page_info.center_width_class" ></CenterNavbar>
      <ContactPageBanner :has_nav_bar="true" id="contact_form_top"></ContactPageBanner>

      <CardedSectionHeader
        icon="mdi-form-select"
        label="Contact Us Form"
      ></CardedSectionHeader>

      <CardedForm
        ref="carded_contact_form_ref"
        id="contact_form"
        title="Leave us a message"
        :is_loading="is_loading"
        @on-submit-form="on_send_message"
        :errors="contact_form_errors"
        :message="contact_us_success_message"
        @on-auto-fill="on_auto_fill"
      >
        <TwoTextFields
          left_label="First name"
          left_icon="mdi-account-circle"
          left_prop="first_name"
          :left_value="first_name"
          :left_validation_rules="first_name_rules"
          :left_required="true"
          right_label="Last name"
          right_icon="mdi-account-circle"
          right_prop="last_name"
          :right_value="last_name"
          :right_validation_rules="last_name_rules"
          :right_required="false"
          @input="on_assign_first_name_and_last_name"
          :disabled="is_loading"
        ></TwoTextFields>

        <TwoTextFields
          left_label="Email Address"
          left_icon="mdi-email-variant"
          left_prop="email"
          :left_value="email"
          :left_validation_rules="email_rules"
          :left_required="true"
          right_label="Phone Number"
          right_icon="mdi-phone"
          right_prop="phone_number"
          :right_value="phone_number"
          :right_validation_rules="phone_number_rules"
          :right_required="true"
          right_type="phone"
          @input="on_assign_email_and_phone_number"
          :disabled="is_loading"
        ></TwoTextFields>

        <TextArea
          label="Message"
          v-model="message"
          :disabled="is_loading"
          :validation_rules="message_rules"
        ></TextArea>
      </CardedForm>

      <CardedSectionHeader
        icon="mdi-form-select"
        label="Contact Details"
        id="contact_contacts_list"
      ></CardedSectionHeader>
      <CardedDisplay>
        <PlainDisplay
          icon="mdi-help-circle-outline"
          title="For any questions and Inquiries "
        >
          <ContactInLineDisplay
            v-for="(contact, index) in page_contacts"
            :key="index"
            :icon="contact.icon"
            :label="contact.label"
            :value="contact.value"
            :remark="contact.remark"
            :protocol="contact.protocol"
          ></ContactInLineDisplay>
          <RedText
            text="Check the right-bottom corner to have live support with our staff"
          ></RedText>
        </PlainDisplay>
        <v-divider></v-divider>
        <PlainDisplay
          id="contact_social_media"
          icon="mdi-account-group"
          title="Find us on social media :"
        >
          <ContactInLineDisplay
            v-for="(contact, index) in page_social_contacts"
            :key="index"
            :icon="contact.icon"
            :label="contact.label"
            :value="contact.value"
            :remark="contact.remark"
            :protocol="contact.protocol"
          ></ContactInLineDisplay>
        </PlainDisplay>
        <v-divider></v-divider>
        <PlainDisplay
          id="contact_map"
          icon="mdi-google-maps"
          :title="`Our offices are located at <b>${page_info.physical_address}</b> :`"
        >
          <div v-html="page_info.embedde_map"></div>
        </PlainDisplay>
      </CardedDisplay>

      <Footer
        :is_loading="is_loading"
        @on-hide-loader="$emit('on-hide-loader')"
        @on-show-loader="$emit('on-show-loader')"
      ></Footer>
    </CenterPageColumn>

    <SidePageColumn side="right">
      <SelfPromoAdd :page="page" section="right" ></SelfPromoAdd>
      <HomeSideAdsContainer :page="page" side="right"  :number_of_ads="3" ></HomeSideAdsContainer>
    </SidePageColumn>
  </Page>
</template>


<script>
import Page from "./../../components/Page";

import SidePageColumn from "./../../components/SidePageColumn";
import QuickSideLinks from "./../../components/QuickSideLinks";
import FeaturedSidePromotions from "./../../components/FeaturedSidePromotions";

import CenterPageColumn from "./../../components/CenterPageColumn";
import CenterNavbar from "./../../components/CenterNavbar";
import ContactPageBanner from "./../../components/ContactPageBanner";
import CardedSectionHeader from "./../../components/CardedSectionHeader";
import CardedForm from "./../../components/CardedForm";
import TwoTextFields from "./../../components/TwoTextFields";
import TextArea from "./../../components/TextArea";
import CardedDisplay from "./../../components/CardedDisplay";
import PlainDisplay from "./../../components/PlainDisplay";
import ContactInLineDisplay from "./../../components/ContactInLineDisplay";
import RedText from "./../../components/RedText";
import Footer from "./../../components/CenterFooter";

import SelfPromoAdd from "./../../components/SelfPromoAdd";
import HomeSideAdsContainer from "./../../components/HomeSideAdsContainer";

import page_info from "./../../lib/page_info";
import Utils from "./../../lib/Utils";
import ServerClient from "./../../lib/ServerClient";

export default {
  name: "Contact",
  components: {
    Page,
    SidePageColumn,
    QuickSideLinks,
    FeaturedSidePromotions,
    CenterPageColumn,
    CenterNavbar,
    ContactPageBanner,
    CardedSectionHeader,
    CardedForm,
    TwoTextFields,
    TextArea,
    CardedDisplay,
    PlainDisplay,
    ContactInLineDisplay,
    RedText,
    Footer,
    SelfPromoAdd,
    HomeSideAdsContainer
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    page: "contact",
    quick_links: [
      {
        text: "Message Form",
        href: "#contact_form_top",
      },
      {
        text: "Contacts List",
        href: "#contact_contacts_list",
      },
      {
        text: "Social Media",
        href: "#contact_social_media",
      },
      {
        text: "Map Location",
        href: "#contact_map",
      },
    ],
    first_name: "",
    first_name_rules: [
      Utils.validate.is_required("First name is required"),
      Utils.validate.min_max_length(
        3,
        25,
        "First name should be between 3 and 25 characters long"
      ),
    ],
    last_name: "",
    last_name_rules: [
      Utils.validate.is_required("Last name is required"),
      Utils.validate.min_max_length(
        3,
        25,
        "Last name should be between 3 and 25 characters long"
      ),
    ],
    email: "",
    email_rules: [
      Utils.validate.is_required("Email address is required"),
      Utils.validate.email_format(
        "Invalide Email format, expected something like myname@xyz.com "
      ),
    ],
    phone_number: "",
    phone_number_rules: [
      Utils.validate.is_required("Phone number is required"),
    ],
    message: "",
    message_rules: [
      Utils.validate.is_required("Message is required"),
      Utils.validate.min_max_length(
        10,
        100,
        "Message length must be between 10 and 100 letters long"
      ),
      Utils.validate.min_words(7, "Message must contain atleast 7 words"),
    ],
    page_info: page_info,
    page_contacts: page_info.get_contacts_list(),
    page_social_contacts: page_info.get_social_media_links(),
    contact_form_errors: [],
    contact_us_success_message: "",
  }),
  mounted() {
    //https://stackoverflow.com/questions/54770883/how-to-navigate-to-different-section-in-the-same-page-using-vuetify
    var options = {
      offset: 102,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#contact_form", options);
  },
  methods: {
    on_auto_fill() {
      var rnd = Math.ceil(Math.random() * 200);
      this.first_name = "Rand_First_Name_" + rnd;
      this.last_name = "Rand_Last_Name_" + rnd;
      this.email = "randemail" + rnd + "@gmail.com";
      this.phone_number = "+267" + (77393543 - (rnd + 37)); //could be right or wrong
      this.message = "This is the a sample mesage of random number " + rnd;
    },
    on_assign_email_and_phone_number(values) {
      this[values.prop] = values.value;
    },
    on_assign_first_name_and_last_name(values) {
      this[values.prop] = values.value;
    },
    on_send_message() {
      //form is already validated
      this.contact_form_errors = [];
      this.contact_us_success_message = "";
      this.$emit("on-show-loader");
      ServerClient.ContactUs.send_message(
        {
          first_name: this.first_name,
          last_name: this.last_name,
          email: this.email,
          phone_number: this.phone_number,
          message: this.message,
        },
        (res) => {
          this.contact_us_success_message =
            "<b class='success--text'>Thank so much </b> for getting in touch with us";
          this.$refs.carded_contact_form_ref.on_clear_form();
          this.$refs.carded_contact_form_ref.show_message_dialog();
          this.$emit("on-hide-loader");
        },
        (errors) => {
          this.contact_form_errors = errors;
          this.$refs.carded_contact_form_ref.show_error_dialog();
          this.$emit("on-hide-loader");
        }
      );
    },
  },
};
</script>